(function () {
  'use strict';

  /* @ngdoc object
   * @name cancellations.newCancellation
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.new', [
      'ui.router'
    ]);
}());
